import baseFetch from "../baseFetch";
import { AB_CONFIG_ENDPOINT, REQUEST_METHODS } from "constants/network";

export const getAbConfigData = async () => {
  return baseFetch({
    url: AB_CONFIG_ENDPOINT,
    method: REQUEST_METHODS.GET,
  });
};
